function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.399948847
}, React.createElement("g", {
  id: "noun_duplicate_1393151-copy",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(-0.000000, 0.000000)"
}, React.createElement("path", {
  d: "M14.2564103,0.102564103 L5.66153846,0.102564103 C4.75522503,0.102564103 4.02051282,0.837276308 4.02051282,1.74358974 L4.02051282,10.3384615 C4.02051282,10.7736886 4.1934061,11.1910899 4.5011581,11.4988419 C4.80891011,11.8065939 5.2263114,11.9794872 5.66153846,11.9794872 L14.2564103,11.9794872 C15.1627237,11.9794872 15.8974359,11.244775 15.8974359,10.3384615 L15.8974359,1.74358974 C15.8974359,0.837276308 15.1627237,0.102564103 14.2564103,0.102564103 Z M5.66153846,10.3384615 L5.66153846,1.74358974 L14.2564103,1.74358974 L14.2564103,10.3384615 L5.66153846,10.3384615 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M1.74358974,15.8974359 L10.3384615,15.8974359 C10.7736886,15.8974359 11.1910899,15.7245426 11.4988419,15.4167906 C11.8065939,15.1090386 11.9794872,14.6916373 11.9794872,14.2564103 L11.9794872,13.2307692 C11.9794872,12.7776125 11.6121311,12.4102564 11.1589744,12.4102564 C10.7058176,12.4102564 10.3384615,12.7776125 10.3384615,13.2307692 L10.3384615,14.2564103 L1.74358974,14.2564103 L1.74358974,5.66153846 L2.81025641,5.66153846 C3.26341313,5.66153846 3.63076923,5.29418236 3.63076923,4.84102564 C3.63076923,4.38786892 3.26341313,4.02051282 2.81025641,4.02051282 L1.74358974,4.02051282 C0.837276308,4.02051282 0.102564103,4.75522503 0.102564103,5.66153846 L0.102564103,14.2564103 C0.102564103,15.1627237 0.837276308,15.8974359 1.74358974,15.8974359 Z",
  id: "Path"
}))));

const SvgDuplicate = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDuplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/duplicate.7260cc2b.svg";
export { ForwardRef as ReactComponent };